function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

export var ActionsTypes = {
  START_SESSION: 'START_SESSION',
  RESET_SESSION: 'RESET_SESSION',
  SET_MOUNTED: 'SET_MOUNTED',
  SET_ACTIVE_TOOL: 'SET_ACTIVE_TOOL',
  SET_ACTIVE_COLOR: 'SET_ACTIVE_COLOR',
  SET_DOCUMENT: 'SET_DOCUMENT',
  SET_PROCESSING: 'SET_PROCESSING',
  SET_REDACT_STEP: 'SET_REDACT_STEP',
  SET_REVIEW_STEP: 'SET_REVIEW_STEP',
  SET_FINISH_STEP: 'SET_FINISH_STEP',
  ADD_CHANGES: 'ADD_CHANGES',
  UPDATE_CHANGES: 'UPDATE_CHANGES',
  UPDATE_STORE: 'UPDATE_STORE',
  UNDO_CHANGES: 'UNDO_CHANGES',
  REDO_CHANGES: 'REDO_CHANGES',
  CLEAR_CHANGES: 'CLEAR_CHANGES'
};

var getNextId = function getNextId() {
  return String(Math.random()).slice(2);
};

export var startSession = function startSession(_ref) {
  var uploadedFile = _ref.uploadedFile,
      uploadedPdfDocument = _ref.uploadedPdfDocument;
  return {
    type: ActionsTypes.START_SESSION,
    payload: {
      uploadedFile: uploadedFile,
      uploadedPdfDocument: uploadedPdfDocument
    }
  };
};
export var setDocument = function setDocument(pdfDocument) {
  return {
    type: ActionsTypes.SET_DOCUMENT,
    payload: {
      pdfDocument: pdfDocument
    }
  };
};
export var setProcessing = function setProcessing(processing) {
  return {
    type: ActionsTypes.SET_PROCESSING,
    payload: {
      processing: processing
    }
  };
};
export var updateStore = function updateStore(payload) {
  return {
    type: ActionsTypes.UPDATE_STORE,
    payload: payload
  };
};
export var setRedactStep = {
  type: ActionsTypes.SET_REDACT_STEP
};
export var setReviewStep = function setReviewStep(url, forceRasterization) {
  return {
    type: ActionsTypes.SET_REVIEW_STEP,
    payload: {
      url: url,
      forceRasterization: forceRasterization
    }
  };
};
export var setFinishStep = function setFinishStep(url) {
  return {
    type: ActionsTypes.SET_FINISH_STEP,
    payload: {
      url: url
    }
  };
};
export var setActiveTool = function setActiveTool(activeTool) {
  return {
    type: ActionsTypes.SET_ACTIVE_TOOL,
    payload: {
      activeTool: activeTool
    }
  };
};
export var setActiveColor = function setActiveColor(activeColor) {
  return {
    type: ActionsTypes.SET_ACTIVE_COLOR,
    payload: {
      activeColor: activeColor
    }
  };
};
export var addChanges = function addChanges(changes) {
  return {
    type: ActionsTypes.ADD_CHANGES,
    payload: {
      changes: _extends({}, changes, {
        id: getNextId()
      })
    }
  };
};
export var updateChanges = function updateChanges(id, changes) {
  return {
    type: ActionsTypes.UPDATE_CHANGES,
    payload: {
      changes: changes,
      id: id
    }
  };
};
export var undoChanges = {
  type: ActionsTypes.UNDO_CHANGES
};
export var redoChanges = {
  type: ActionsTypes.REDO_CHANGES
};
export var clearChanges = {
  type: ActionsTypes.CLEAR_CHANGES
};
export var setMounted = {
  type: ActionsTypes.SET_MOUNTED
};
export var resetSession = {
  type: ActionsTypes.RESET_SESSION
};